import request from '@/router/axios'

// 出勤记录报表
export const getSalarySettlementList = (current, size, params) => request({
  url: '/api/mcc-worker/workersalarysettlement/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const getWorkerInfoSettlement = params => request({
  url: '/api/mcc-worker/workersalarysettlement/getSalarySettlement',
  method: 'get',
  params: {
    ...params,
  },
})

export const getSalarySettlementDetail = params => request({
  url: '/api/mcc-worker/workersalarysettlement/detail',
  method: 'get',
  params: {
    ...params,
  },
})

export const getCancelSalarySettlement = params => request({
  url: '/api/mcc-worker/workersalarysettlement/removeSalarySettlement',
  method: 'post',
  params: {
    ...params,
  },
})

export const saveSalary = params => request({
  url: '/api/mcc-worker/workersalarysettlement/save',
  method: 'post',
  data: {
    ...params,
  },
})

export const updateSalary = params => request({
  url: '/api/mcc-worker/workersalarysettlement/update',
  method: 'post',
  data: {
    ...params,
  },
})

export const sendSalary = params => request({
  url: '/api/mcc-worker/workersalarysettlement/send',
  method: 'post',
  data: {
    ...params,
  },
})

// 获取课程字典
export const getSalarySettlementDict = params => request({
  url: '/api/mcc-worker/workersalarysettlement/getSalarySettlementDict',
  method: 'get',
  params: {
    ...params,
  },
})

export const startProcess = (params, headers) => request({
  url: '/api/mcc-worker/processfield/startSalarySettlementProcess',
  method: 'post',
  headers,
  data: {
    ...params,
  },
})
export const generatePDF = params => request({
  url: '/api/mcc-worker/workersalarysettlement/generate',
  method: 'post',
  params: {
    ...params,
  },
})

export default {
  getSalarySettlementList,
}
